import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import { faGlobe } from "@fortawesome/free-solid-svg-icons";
const Footer = () => {
  return (
    <footer className="W-100 bg-dark text-white py-3 mt-5">
      <div className="container">
        <div
          className=" d-flex justify-content-between align-items-center flex-wrap row "
          id="footer"
        >
          <div className="h-100 text-end w-auto col-lg-4 col-md-16 col-sm-12">
            Info@q8maps.com
          </div>
          <div className=" h-100 text-end w-auto col-lg-4 col-md-16 col-sm-12">
            <span>powered by Q8maps &copy; 2023</span>
          </div>
          <div className="h-100 text-end w-auto col-lg-4 col-md-16 col-sm-12">
            <div className="d-flex justify-content-end align-items-center">
              <a
                href="https://www.instagram.com/q8.maps/"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  className="text-white me-2"
                />
              </a>
              <a
                // href="https://wa.me/+96565111161"
                href="#"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  className="text-white me-2"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
